import { render, staticRenderFns } from "./BoxImg.vue?vue&type=template&id=47fc1635&scoped=true&"
import script from "./BoxImg.vue?vue&type=script&lang=js&"
export * from "./BoxImg.vue?vue&type=script&lang=js&"
import style0 from "./BoxImg.vue?vue&type=style&index=0&id=47fc1635&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc1635",
  null
  
)

export default component.exports